<template lang="pug">
#activity_post
  .atpTOP
    .atp_top_left
      ImgLoader.atp_img(
        v-if="post_data != null"
        :img="post_data.cover_photo"
        :style="{'--default-url': `url(${defaultImg})`, '--bgPos':'center', '--bgSize':'cover'}"
      )
    .atp_top_right
      .atp_title(v-if="post_data != null") {{ post_data.title }}
      //- .atp_date {{post_data.date}}
      .atp_tab {{ tab }}
      .atp_button_box(v-if="this.applicationFormId")
        .atp_button_text(@click="to_apply()") 我要報名
      //- .atp_button_mode_box
      //-   .atp_mode_text {{post_data.mode}}
  .atpBOTTOM
    .atp_bottom_left
      .atp_body(v-if="post_data != null" v-html="post_data.body")
    .atp_bottom_right
      .atp_tags_box
        //- .atp_tags(v-for="tag in post_data.tags") # {{tag.name}}
</template>

<script>
import { fetchArticle } from '@/api/client/Articles'
import ImgLoader from '../../components/ImgLoader.vue';
export default {
  data() {
    return {
      defaultImg: require('../../assets/default.png'),
      tab: null,
      post_data: null,
      applicationFormId: null
    };
  },
  async created() {
    await this.ApiGetArticle(this.$route.params.postid, this.$route.query.dbid);
  },
  methods: {
    to_apply() {
      if (this.applicationFormId == null) return
      const { href } = this.$router.resolve({ 
        name: 'applicationForm', 
        params: { formId: this.applicationFormId }
      })
      window.open(href, '_blank')
    },
    //get article
    async ApiGetArticle(postId, dbId) {
      const { data } = await fetchArticle(postId, dbId);
      if (data == null) return
      this.post_data = data
      const { application_form } = data
      if (application_form == null) return
      this.applicationFormId = application_form.id
    }
  },
  components: { ImgLoader }
}
</script>

<style lang="sass">
@import '@/assets/style_activity.sass'


#activity_post
  width: 100%
  box-sizing: border-box
  +flexcolumn
  padding-inline: 20px
  .atpTOP
    width: 100%
    box-sizing: border-box
    +flexrow
    +padpro
      +flexcolumn

    .atp_top_left
      width: 60%
      box-sizing: border-box
      padding: 0 2vw 0 0
      +padpro
        width: 100%
        padding: 0

      .atp_img
        background-repeat: no-repeat !important
        background-size: 100% auto !important
        +size(100%,25vw)
        +lgcom
          +size(100%,28vw)
        +com
          +size(100%,31vw)
        +smallcom
          +size(100%,34vw)
        +padpro
          +size(100%,45vw)

    .atp_top_right
      width: 40%
      box-sizing: border-box
      padding: 10vw 0 0 0
      border-bottom: solid 1px $lightgray
      margin-left: 2vw
      +padpro
        width: 100%
        margin-left: 0
        padding: 30px 0 15px 0
      +phone
        padding: 15px 0 15px 0

      .atp_title
        font-size: 35px
        font-weight: 800
        text-align: justify
        line-height: 45px
        letter-spacing: 2px
        color: $darkgray
        +padpro
          font-size: 30px
          line-height: 40px
        +phone
          font-size: 25px
          line-height: 35px
          letter-spacing: 1px

      .atp_date
        font-size: 16px
        letter-spacing: 1px
        margin-top: 60px
        +padpro
          margin-top: 30px
        +phone
          margin-top: 20px

      .atp_tab
        font-size: 16px
        letter-spacing: 1px
        // margin-top: 15px
        margin-top: 60px
        +padpro
          // margin-top: 10px
          margin-top: 30px
        +phone
          // margin-top: 5px
          margin-top: 20px

      .atp_button_box
        padding: 5px 12px
        border: solid 1px $darkgray
        border-radius: 7px
        position: absolute
        bottom: 15px
        right: 0
        cursor: pointer
        text-decoration: none
        color: black
        +padpro
          position: relative
          float: right
          margin-top: 20px
          bottom: 0
        +phone
          margin-top: 10px
        &:hover
          background: $darkgray
          .atp_button_text
            color: white

        .atp_button_text
          font-size: 16px
          font-weight: 800
          letter-spacing: 1px
          text-align: center
          color: black

      .atp_button_mode_box
        padding: 5px 12px
        border: solid 1px $gray
        border-radius: 7px
        position: absolute
        bottom: 15px
        right: 0
        +padpro
          position: relative
          float: right
          margin-top: 20px
          bottom: 0
        +phone
          margin-top: 10px

        .atp_mode_text
          font-size: 16px
          font-weight: 800
          letter-spacing: 1px
          text-align: center
          color: $gray

  .atpBOTTOM
    width: 100%
    box-sizing: border-box
    +flexrow
    margin-top: 2vw
    +padpro
      +flexcolumn

    .atp_bottom_left
      width: 60%
      box-sizing: border-box
      padding: 0 2vw 0 0
      +padpro
        width: 100%
        padding: 0

      .atp_body
        font-size: 16px
        text-align: justify
        line-height: 28px
        letter-spacing: 1px

    .atp_bottom_right
      width: 40%
      box-sizing: border-box
      margin: 18px 0 0 2vw
      +padpro
        width: 100%
        margin: 30px 0 0 0

      .atp_tags_box
        +flexrow
        +phone
          +flexcolumn

        .atp_tags
          font-size: 15px
          color: $lightgray
          margin-right: 20px
          cursor: pointer
          +phone
            margin: 0 0 10px 0
          &:hover
            color: black

</style>


// WEBPACK FOOTER //
// src/views/activity_school/activity_post.vue